import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import type { Planbook } from "@shared/models/planbook"
import type EmberStore from "cc-frontend/services/ember-store"
import type Rpc from "cc-frontend/services/rpc"

@tagName("")
export default class PlanbookMenuEditTitleBodyComponent extends Component {
  //args
  planbook!: Planbook

  // services
  @service("ember-store") store!: EmberStore
  @service rpc!: Rpc

  @action
  deletePlanbook() {
    this.rpc.execute("PLANBOOK_DELETE", this.planbook.id).then(() => {
      window.location.href = "/users/" + this.planbook.relationships.owner.data.id
      // Ember.getOwner(this).lookup('router:main').transitionTo('user.show.index', get(this, "owner.id"))
    })
  }
}
